// extracted by mini-css-extract-plugin
module.exports = {"container":"e_gw","pending":"e_hw","slider":"e_iw","imageContainer":"e_jw","image":"e_kw","button":"e_lw","prevButton":"e_mw","nextButton":"e_nw","disabled":"e_ow"};